import React from "react";

/**
 * Breakout Scanner brand mark — bull mascot + green breakout arrow.
 *
 * On both light and dark backgrounds the raw PNG can feel a bit quiet, so we
 * wrap it in a soft radial glow + subtle ring which renders cleanly on either
 * theme. `withWordmark` keeps the original behaviour for places that want a
 * tiny mark beside a separate text wordmark.
 */
export default function Logo({ size = 36, withWordmark = false, className = "", plain = false }) {
  const inner = (
    <img
      src="/logo-mark.png"
      alt="Breakout Scanner"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
      draggable={false}
      loading="eager"
      decoding="async"
      data-testid="brand-logo"
    />
  );

  return (
    <span className={"inline-flex items-center gap-2.5 " + className}>
      {plain ? (
        inner
      ) : (
        <span
          aria-hidden={false}
          className="relative inline-flex items-center justify-center shrink-0"
          style={{ width: size, height: size }}
        >
          {/* soft glow — green, subtle; visible on both light + dark backgrounds */}
          <span
            aria-hidden
            className="absolute inset-0 rounded-full blur-md opacity-70"
            style={{
              background:
                "radial-gradient(circle at 50% 50%, hsl(160 84% 45% / 0.45), transparent 70%)",
            }}
          />
          <span className="relative inline-flex items-center justify-center">{inner}</span>
        </span>
      )}
      {withWordmark && (
        <span className="inline-flex items-baseline gap-1.5 font-mono tracking-[0.22em] uppercase">
          <span className="text-primary-fg">Breakout</span>
          <span className="text-pos">Scanner</span>
        </span>
      )}
    </span>
  );
}
